import UsersContract from 'decentralized/contracts/usersContract.js';
import {lstorage} from 'utils/lstorage.js';
import accounts from 'accounts/Accounts.js';
import ipfs from 'decentralized/Ipfs.js';
const usersContract = new UsersContract();
const bs58 = require('bs58');

class EthereumUsers {
    constructor(web3) {
        this.web3 = web3;
        this.cachedUserNames = {};
    }

    isUserNameAvailable(userName) {
        return new Promise(async (resolve, reject) => {
            const address = await accounts.getAccount();
            let contract = usersContract.getContract(this.web3);
            try {
                let isAvailable = await contract.methods.isUserNameAvailable(userName).call()
                resolve(isAvailable);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    }

    getUserId(userName) {
        return new Promise(async (resolve, reject) => {
            const address = await accounts.getAccount();
            let contract = usersContract.getContract(this.web3);
            try {
                let userAddress = await contract.methods.getUserAddressFromName(userName).call()
                resolve(userAddress);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    }

    setUserName(name) {
        return new Promise(async (resolve, reject) => {
            let contract = usersContract.getContract(this.web3);
            contract.methods.setName(name).send({
                from: await accounts.getAccount()
            }, (error, transactionHash) => {
                if (error) {
                    reject(error);
                } else {
                    resolve();
                }
            });
        
        });
    }

    setProfile(profile) {
        return new Promise(async (resolve, reject) => {
            const accounts = await accounts.getACCOUNT();
            let hash = await ipfs.addJson(profile);
            hash = ipfsHashToBytes32(hash);
            let contract = usersContract.getContract(this.web3);
            contract.methods.setProfileHash(hash).send({
                from: accounts[0] 
            }, (error, transactionHash) => {
                if (error) {
                    reject(error);
                } else {
                    resolve();
                }
            });
        
        });
    }

    getUserName(address) {
        return new Promise(async (resolve, reject) => {
            let storage = lstorage;
            if (this.cachedUserNames[address]) {
                resolve(this.cachedUserNames[address]);
                return;
            }
            if (!window.isNFT && storage.getItem('username:' + address)) {
                resolve(storage.getItem("username:" + address));
                return;
            }
            if (address === undefined || address === "") {
                address = await accounts.getAccount();
            }
            if (address === undefined) {
                resolve(undefined);
                return;
            }
            if (address in this.cachedUserNames) {
                resolve(this.cachedUserNames[address]);
                return;
            }
            let contract = usersContract.getContract(this.web3);
            try {
                let name = await contract.methods.getUserName(address).call();
                storage.setItem("username:" + address, name);
                if (name === '') {
                    resolve(undefined);
                    return;
                }
                this.cachedUserNames[address] = name;
                resolve(name);
            } catch (error) {
                reject(error);
            }
        });
    }

    getProfile(address) {
        return new Promise(async (resolve, reject) => {
            if (address === undefined) {
                const account = await accounts.getAccount();
                if (account === undefined) {
                    reject('no ethereum');
                    return;
                }
                address = account;
            }
            let contract = usersContract.getContract(this.web3);
            let ipfsHash = await contract.methods.getUserProfile(address).call();
            try {
                if (this.web3.utils.hexToNumber(ipfsHash) === 0) {
                    resolve('no profile');
                    return;
                }
            } catch (err) {
                console.log('had error while trying to get profile');
            }
            ipfsHash = bytes32ToIPFSHash(ipfsHash);
            let profile = await ipfs.getJson(ipfsHash);
            resolve(profile);
        });
    }
}

function ipfsHashToBytes32(ipfs_hash) {
    var h = bs58.decode(ipfs_hash).toString('hex').replace(/^1220/, '');
    if (h.length != 64) {
        return null;
    }
    return '0x' + h;
}

function bytes32ToIPFSHash(hash_hex) {
    //console.log('bytes32ToIPFSHash starts with hash_buffer', hash_hex.replace(/^0x/, ''));
    var buf = new Buffer(hash_hex.replace(/^0x/, '1220'), 'hex')
    return bs58.encode(buf)
}

export default EthereumUsers;
